export const URI_TEMPLATE_TAG = '/template/tag';
export const URI_DELETE_TEMPLATE_TAG = '/template/private-template-tag';

export const URI_BIND_TEMPLATE_TAG = (
	tag: number,
	template: string,
) => `${URI_TEMPLATE_TAG}/${tag}/template/${template}`;
